<div class="container-fluid text-center mt-3">
    <div class="mb-2 bg-white mm-empty-state"></div>
    <p class="mt-2 fw-light">{{message}}</p>
</div>
